<template>
     <v-footer fixed style="margin-top:10px;" >
      <v-col class="text-center" cols="12">2021 | TCE-MA - Todos os Direitos Reservados </v-col>
    </v-footer>
</template>

<script>
export default {
}
</script>

<style>

</style>